import { jsx as r } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import d from "@mui/material/Badge";
import g from "styled-components";
import { getFlavorColor as l, flavors as s } from "../../theme/utils/styleUtils.js";
const n = {
  root: "badgeRoot",
  badge: "badgeBadge",
  dot: "badgeDot",
  invisible: "badgeInvisible"
}, p = g(d).withConfig({
  displayName: "StyledBadge"
})([
  "&& .badgeBadge{height:18px;min-width:18px;padding:0 5px;background-color:",
  ";color:",
  ";font-size:",
  ";font-weight:",
  ";transform:scale(1) translate(100%,-50%);}&& .badgeInvisible{transform:scale(0) translate(50%,-50%);}&& .badgeDot{height:6px;width:6px;min-width:6px;padding:0;border-radius:6px;}"
], ({ theme: o, $flavor: a }) => l(o, a), ({ theme: o }) => o.colors.white, ({ theme: o }) => o.typography.body100.fontSize, ({ theme: o }) => o.typography.fontWeightMedium), f = /* @__PURE__ */ i(({ classes: o, flavor: a = s.normal, ...t }, e) => /* @__PURE__ */ r(p, {
  ...t,
  ref: e,
  classes: {
    ...n,
    ...o
  },
  anchorOrigin: {
    horizontal: "right",
    vertical: "top"
  },
  $flavor: a,
  color: "default"
}));
f.displayName = "Badge";
export {
  f as default
};
